<template>
    <transition name="setDialog">
        <!-- 去设置弹层 -->
        <div class="setDialogWrap" v-show="visible" data-close @click="_close">
            <div class="setDialog" :class="{'fade-in':isShow,'fade-out':!isShow}">
                <div class="title">
                    <h3>精准营销</h3>
                    <span>（京东官方）</span>
                </div>
                <p class="desc">
                    云短信CRM的精准营销依托京东大数据引擎，基于平台客户标签，针对不同标签组合筛选出人群包，在不同营销场景进
                    行精准触达，为商家提供多样化多渠道的运营策略和智能、个性化解决方案。促进访客、粉丝转化和提升老客粘性,最终提升客户价值。
                </p>

                <div class="swiper-content">
                    <swiper class="swiper" :options="swiperOption">
                        <swiper-slide>
                            <div class="sortItem" :style="swiperBg1">
                                <div class="buttonBox">
                                    <button @click="setSuffix">设置</button>
                                    <button @click="createGrouping">设置</button>
                                    <button @click="dialogClose">设置</button>
                                </div>
                            </div>
                        </swiper-slide>
                        <swiper-slide>
                            <div class="sortItem" :style="swiperBg2">
                            </div>
                        </swiper-slide>
                        <div class="swiper-pagination" slot="pagination"></div>
                    </swiper>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
export default {
    props: {
        visible: {
            type: Boolean,
            default: false
        }
    },
    watch: {
        visible() {
            if (this.visible) {
                document.documentElement.style.overflow='hidden';
            } else {
                document.documentElement.style.overflow='auto';
            }
        }
    },
    data() {
        return {
            swiperOption: {
                autoplay:{
                    delay:5000,
                    disableOnInteraction:false
                },
                speed: 600,
                pagination: {
                    el: '.swiper-pagination',
                    clickable :true,
                }
            },
            isShow: true,
            swiperBg1: {
                backgroundImage: "url("+require('@/assets/images/goSetimg1.png')+")"
            },
            swiperBg2: {
                backgroundImage: "url("+require('@/assets/images/goSetimg2.png')+")"
            }
        }
    },
    methods: {
    //  runInv () {
    //   this.timer = setInterval(() => {
    //     this.gotoPage(this.nextIndex)
    //   }, 1000)
    // }
    //   },
        _close(e) {
            const type = e.target.dataset.close;
            if (type === undefined) {
                return
            }
            this.isShow = false;
            setTimeout(() => {
                this.isShow = true;
                this.$emit('close', false);
            }, 200)
        },
        dialogClose(){
            let routeUrl = this.$router.resolve({
                path: "/marketing/marketing/accurate_market",
            });
            window.open(routeUrl.href, '_blank');
        },
        setSuffix(){
            let routeUrl = this.$router.resolve({
                path: "/backstage/signature_management/signature_report_official",
            });
            window.open(routeUrl.href, '_blank');
        },
        createGrouping(){
            this.isShow = false;
            setTimeout(() => {
                this.isShow = true;
                this.$emit('close', false);
            }, 200)
            // this.$parent.labelCircle()
            
        }
    },
}
</script>

<style scoped lang="scss">
.setDialogWrap {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    overflow: auto;
    z-index: 3333;
    background:rgba(0,0,0,0.2);
    transition: all .3s;
    .setDialog {
        box-sizing: border-box;
        position: relative;
        margin: 15vh auto 0;
        background: #fff;
        border-radius:6px;
        box-shadow: 0 1px 3px rgba(0,0,0,.3);
        transition: all .3s;
        width: 800px;
        height: 500px;
        .title {
            height: 70px;
            line-height: 70px;
            text-align: center;
            vertical-align: bottom;
            border-bottom: 1px solid #ddd;
            h3 {
                display: inline-block;
                margin: 0;
                color: #333;
                font-size: 24px;
                font-weight: 500;
            }
            span {
                color: #FE4D45;
                font-size: 18px;
                font-weight: 400;
            }
        }
        .desc {
            margin: 15px 35px;
            color: #333;
            line-height: 20px;
            font-size: 14px;
            font-weight: 400;
        }
        .swiper-content {
            width: 760px;
            height: 340px;
            margin: 0 auto;
            /deep/ .swiper-pagination {
                position: relative;
                transform: translateY(-20px);
                box-sizing: border-box;
                padding-right: 15px;
                text-align: right;
                &::after {
                    content: '*注：此功能通过京东官方短信通道发送短信，所报备签名与云短信CRM其他功能签名不同。';
                    position: absolute;
                    left: 15px;
                    top: 10px;
                    color: #FE4D45;
                    font-size: 14px;
                }
                .swiper-pagination-bullet{
                    width: 8px;
                    height: 8px;
                    // background: #FE4D45;
                }
                // /deep/ .swiper-pagination-bullet-active{
                //     background-color: #FE4D45;
                //     width: 8px;
                //     height: 8px;
                // }
            }
            .sortItem {
                position: relative;
                width: 100%;
                height: 320px;
                
                background-repeat: no-repeat;
                .buttonBox {
                    display: flex;
                    justify-content: space-around;
                    box-sizing: border-box;
                    padding: 0 10px;
                    position: absolute;
                    left: 0;
                    bottom: 50px;
                    width: 100%;
                    button {
                        outline: none;
                        border: none;
                        width: 120px;
                        height: 32px;
                        line-height: 32px;
                        background: linear-gradient(270deg, #FF6D6E 0%, #FE333B 100%);
                        border-radius: 16px;
                        cursor: pointer;
                        color: #fff;
                        text-align: center;
                        font-size: 16px;
                        font-weight: 400;
                    }
                }
            }
        }
    }
}
.setDialog-enter { animation: popup-mask-fade-in .3s ease; }
.setDialog-leave { 
    animation: popup-mask-fade-out .1s ease forwards; 
    transform: translate3d(0, -10%, 0);
    background-color: rgba(0,0,0,0.1);
    opacity: 0;
}
.setDialog-enter-active { animation: popup-mask-fade-in .3s ease; }
.setDialog-leave-active { 
    animation: popup-mask-fade-out .1s ease forwards; 
    transform: translate3d(0, -10%, 0);
    background-color: rgba(0,0,0,0.1);
    opacity: 0;
}
@keyframes fade-in {
    0% {
        opacity: 0;
        transform: translate3d(0, -100%, 0);
    }
    100% {
        transform: translate3d(0, 0, 0);
        opacity: 1;
    }
}
@keyframes fade-out {
    0% {
        transform: translate3d(0, 0, 0);
        opacity: 1;
    }
    100% {
        transform: translate3d(0, -100%, 0);
        opacity: 0;
    }
}
.fade-in {
    animation: fade-in .3s ease;
}
.fade-out {
    opacity: 0;
    transform: translate3d(0, -100%, 0);
    animation: fade-out .3s ease;
}
@keyframes popup-mask-fade-in {
    0% {
        opacity: 0;
    }
    100% {
        opacity: 1;
    }
}
@keyframes popup-mask-fade-out {
    0% {
        opacity: 1;
    }
    100% {
        opacity: 0;
    }
}
</style>